<div class="h-80 bg-[#00666629] lg:p-10 p-6">
    <div class="flex flex-col items-center h-full">
        <h1 class="lg:text-3xl font-medium text-[#006666]">ChemPlatform</h1>
        <p class="lg:text-5xl font-semibold text-[#006666] text-xl mt-4">Easy access to all your chemicals</p>
        <p class="lg:text-xl font-medium text-[#006666] mt-3">Find all information you need about your chemicals</p>
    </div>
</div>